export default __webpack_public_path__ + "static/media/ECA_LOGO_FR.eac11841.webp";